export default {"src":"https://webcdn.trailways.com/_next/static/media/us.9c3a3982.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};